import React from "react";
import OrdersDB from "./OrdersDB";
import StockDB from "./StockDB";

const DashboardCt = () => {
  return (
    <div className="w-full p-4">
      <h1 className="text-xl sm:text-2xl xl:text-[30px] text-G800 font-semibold mb-3">
        Dashboard
      </h1>
      <div className="flex flex-col lg:flex lg:flex-row gap-6">
        <div className="w-full lg:w-[70%]">
          <OrdersDB />
        </div>
        <div className="w-full md:w-[362px]">
          <StockDB />
        </div>
      </div>
    </div>
  );
};

export default DashboardCt;
